import clsx from 'clsx';
import Button from 'components/atoms/Button/Button';
import Overlay from 'components/atoms/Overlay/Overlay';
import React from 'react';
import { MdClose } from 'react-icons/md';
import classes from './Modal.module.scss';

export interface Props {
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  buttonsClassName?: string;
  buttons: React.ReactNode;
  onClose?: () => void;
  noMinWidth?: boolean;
  showOverflow?: boolean;
}

const Modal: React.FC<Props> = ({
  children,
  className,
  bodyClassName,
  buttonsClassName,
  onClose,
  buttons,
  noMinWidth,
  showOverflow,
}) => {
  return (
    <Overlay onBackgroundInteraction={onClose}>
      <div
        className={clsx(
          classes.root,
          noMinWidth && classes.noMinWidth,
          showOverflow && classes.showOverflow,
          !onClose && classes.noCloseButton,
          className,
        )}
      >
        {Boolean(onClose) && (
          <div className={classes.header}>
            <Button className={classes.closeButton} onClick={onClose}>
              <MdClose className={classes.closeIcon} />
            </Button>
          </div>
        )}
        <div className={clsx(classes.body, bodyClassName)}>
          <div>{children}</div>
        </div>
        <div className={clsx(classes.buttons, buttonsClassName)}>{buttons}</div>
      </div>
    </Overlay>
  );
};

export default Modal;
